import { CartUpdatedEvent } from '@theme/events';

/**
 * Si le produit principal (ancre) n’est plus dans le panier alors qu’il reste des articles,
 * vide entièrement le panier (cross-sells / add-ons seuls interdits).
 * @param {{ anchorProductId: string, cartDrawerSectionId?: string }} options
 * @returns {Promise<boolean>} true si le panier a été vidé côté serveur
 */
export async function enforceCartAnchorProduct({ anchorProductId, cartDrawerSectionId }) {
  if (!anchorProductId) return false;

  const cartRes = await fetch(`${Theme.routes.cart_url}.js`);
  if (!cartRes.ok) return false;

  const cart = await cartRes.json();
  const hasAnchor = cart.items.some((item) => String(item.product_id) === String(anchorProductId));

  if (hasAnchor || cart.items.length === 0) return false;

  const body = {};
  if (cartDrawerSectionId) {
    body.sections = cartDrawerSectionId;
    body.sections_url = window.location.pathname;
  }

  const clearRes = await fetch(`${Theme.routes.cart_url}/clear.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });

  if (!clearRes.ok) return false;

  const cleared = await clearRes.json();

  if (window.location.pathname.includes('/cart')) {
    window.location.reload();
    return true;
  }

  document.dispatchEvent(
    new CartUpdatedEvent(
      {},
      {
        itemCount: cleared.item_count ?? 0,
        source: 'cart-anchor-product',
        sections: cleared.sections,
      },
    ),
  );

  return true;
}

/** Au chargement de /cart : applique la règle si le tiroir panier expose un produit ancre. */
export function enforceCartAnchorProductOnCartPage() {
  if (!window.location.pathname.includes('/cart')) return;

  const drawer = document.querySelector('cart-drawer');
  const anchorId = drawer?.dataset?.anchorProductId;
  if (!anchorId) return;

  void enforceCartAnchorProduct({
    anchorProductId: anchorId,
    cartDrawerSectionId: drawer?.dataset?.sectionId,
  });
}
